import { Component } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Images
import Image1 from "../../../images/slider/slide3.jpg"
import panda from "../../../images/slider/panda.webp"

import { withTranslation } from 'react-i18next';

class Slider2 extends Component {
	constructor(props) {
		super(props);
		this.next = this.next.bind(this);
		this.previous = this.previous.bind(this);
	}
	componentDidMount() {
		this.interval = setInterval(() => {
			this.next();
		}, 8000);
	}
	componentWillUnmount() {
		clearInterval(this.interval);
	}
	next() {
		this.slider.slickNext();
	}
	previous() {
		this.slider.slickPrev();
	}
	render() {
		const { t } = this.props;
		const settings = {
			infinite: true,
			speed: 1000,
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: true,
			initialSlide: 0,
		};

		return (
			<>
				<div className='slider-container' style={{ borderRadius: '12px', overflow: 'hidden' }}>
					<Slider ref={c => (this.slider = c)} {...settings} className="slideshow-container tt-slider slider-two slider-sp0 owl-none">
						<div className="slider-item" key={1}>
							<div className="slider-thumb">
								<img alt="" src={Image1} style={{ borderRadius: '12px', display: 'block', width: '100%' }} />
							</div>
							<div className="slider-content">
								<div className="container">
									<div className="row align-items-center">
										<div className="col-lg-7 col-md-12 col-sm-12">
											<div className="content-inner">
												<h2 className="text-primary">{t('Slider2_Prititle2')}</h2>
												<p>{t('Slider2_Description')}</p>
											</div>
										</div>
										<div className="col-lg-5 col-md-12 col-sm-12">
											<div className="slider-img" style={{ width: '120%' }}>
												<img alt="" src={panda} style={{ borderRadius: '12px', display: 'block', maxWidth: '100%' }} />
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</Slider>
				</div>
			</>
		);
	}
}

export default Slider2 = withTranslation()(Slider2);